import { COLORS } from 'constants/index';

const palette = {
  primary: {
    // light: will be calculated from palette.primary.main,
    main: COLORS.BLUE,
    // dark: will be calculated from palette.primary.main,
    contrastText: COLORS.WHITE
  },
  secondary: {
    // light: will be calculated from palette.primary.main,
    main: COLORS.BLACK_LIGHT,
    // dark: will be calculated from palette.secondary.main,
    // contrastText: will be calculated to contrast with palette.primary.main
  },
  error: {
    main: COLORS.RED,
  },
  success: {
    main: COLORS.GREEN,
  }
};

export default palette;